import React from 'react';
import TeacherBannerBuy from '../../prelogin/src/components/TeacherBannerBuy';

export default class TopBanner extends TeacherBannerBuy{
	
	render() {
  	
  	return(
  		<section className={this.props.classes+" tchrhead"} >
  		<div className="container"> 
		  <div>
			<h1>{this.rb("sg.products.heading")}</h1>   
			{/*<h1>{this.rb("sg.products.heading1")}</h1> */}
		  </div>
		  <div className="tchrdiv">
		  <h2>{this.rb("sg.products.subheading")} <br/>
		  {this.rb("sg.products.subheading1")}</h2>
		  </div>        
  		</div> 
  		</section>
  		);
  	}
}


// WEBPACK FOOTER //
// ./src/views/others/TopBanner.js